document.addEventListener('teeinblue-event-after-cart-added', function() {
  document.dispatchEvent(
    new CustomEvent('cart:refresh', {
      detail: { open: true }
    })
  );
  
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
        source: 'teeinblue-event-after-cart-added',
        cart,
      });
    })
    .catch(e => {});
});

document.addEventListener('error', function (e) {
  if (e.target.tagName.toLowerCase() === 'img' && e.target.src.includes('teeinblue')) {
    let img = e.target;
    console.log(img)
    let retryCount = parseInt(img.dataset.retry) || 0;
    const maxRetries = 5; 
    const delay = 1000;

    if (retryCount < maxRetries) {
      setTimeout(function () {
        img.dataset.retry = retryCount + 1;
        const url = new URL(img.src);
        url.searchParams.set('retry', img.dataset.retry);
        img.src = url.toString();
      }, delay);
    } else {
        img.src = '';
    }
  }
}, true);